import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
	InputSignal,
	Signal,
	ViewEncapsulation
} from "@angular/core";
import { ReferenceDataState, selectReferenceDataStatus } from "@core/reference-data";
import { Store } from "@ngrx/store";
import { isLoading, StoreStatus } from "@utility/state";
import { TradeCostAnalysisSummaryResponse } from "../../../../models/api/responses/summary/trade-cost-analysis-summary.response.model";
import { TradeCostAnalysisFormType } from "../../../../models/forms/trade-cost-analysis-form.type";
import { TradeCostAnalysisSummaryComponent } from "../../../summary/trade-cost-analysis-summary/trade-cost-analysis-summary.component";

@Component({
	selector: "lib-trade-cost-analysis-widget-summary",
	imports: [TradeCostAnalysisSummaryComponent],
	templateUrl: "./trade-cost-analysis-widget-summary.component.html",
	styleUrl: "./trade-cost-analysis-widget-summary.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.ShadowDom
})
export class TradeCostAnalysisWidgetSummaryComponent {
	protected readonly referenceDataStore = inject(Store<ReferenceDataState>);

	public readonly summary$: InputSignal<TradeCostAnalysisSummaryResponse> = input.required();
	public readonly type$: InputSignal<TradeCostAnalysisFormType> = input.required();

	protected readonly configurationState$: Signal<StoreStatus> =
		this.referenceDataStore.selectSignal(selectReferenceDataStatus);

	protected readonly isLoading$: Signal<boolean> = computed(() => {
		return isLoading(this.configurationState$());
	});

	protected readonly isLiveAnalysis$: Signal<boolean> = computed(() => {
		return this.type$() === "live";
	});
}
